import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "fight",
    component: () => import("../views/FightView.vue"),
  },
  {
    path: "/smithy",
    name: "smithy",
    component: () => import("../views/SmithyView.vue"),
  },
  {
    path: "/inventory",
    name: "inventory",
    component: () => import("../views/InventoryView.vue"),
  },
  {
    path: "/item/:id",
    name: "item-detail",
    component: () => import("../views/ItemDetailView.vue"),
  },
  {
    path: "/log",
    name: "log",
    component: () => import("../views/LogView.vue"),
  },
  {
    path: "/workflows",
    name: "workflows",
    component: () => import("../views/WorkflowsView.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
